import { render } from "./NewLeads.vue?vue&type=template&id=1abf8f16&scoped=true"
import script from "./NewLeads.vue?vue&type=script&lang=js"
export * from "./NewLeads.vue?vue&type=script&lang=js"

import "./NewLeads.vue?vue&type=style&index=0&id=1abf8f16&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abf8f16"]])

export default __exports__